import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { EnquiryIdContainer } from "../EnquiryId/EnquiryId.styled";
import { GrayPara } from "../../EnquiryList.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import "../../EnquiryList.scss";

const SiteInfo = (props) => {
  const { t, data } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={data.isActive ? 1 : "0.2"}>
        <EnquiryIdContainer>
          <Link
            to={`/site/view/${data.siteId}/general-info`}
            className="enquiry-listin__enquiry-list-link"
          >
            {"#" + data.siteId + " " + data.siteName}
          </Link>
        </EnquiryIdContainer>
        <EnquiryIdContainer>
          {" "}
          <GrayPara>{data.companyName} </GrayPara>
        </EnquiryIdContainer>
      </DivBackgroundOpacity>
    </>
  );
};

SiteInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SiteInfo);
